import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * ตัวจัดการสถานะ loading รวมทั้งแอป — นับจำนวน request ที่กำลังค้างอยู่
 * (HTTP interceptor เรียก start()/stop()) แล้ว overlay ใน app.component ฟัง loading$
 */
@Injectable({ providedIn: 'root' })
export class LoadingService {
  private _count = 0;
  loading$ = new BehaviorSubject<boolean>(false);

  start() {
    this._count++;
    if (this._count === 1) this.loading$.next(true);
  }

  stop() {
    if (this._count > 0) this._count--;
    if (this._count === 0) this.loading$.next(false);
  }
}
